"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIGNUP_REDESIGN_PALETTE = void 0;
const SIGNUP_REDESIGN_PALETTE = exports.SIGNUP_REDESIGN_PALETTE = {
  primary: '#007AEB',
  secondary: '#67768D',
  grey: '#E2E8F0',
  black: '#020817',
  error: '#EF4444',
  warning: '#EFB544',
  success: '#5BC828',
  info: '#EFF6FF'
};